import * as yup from 'yup';

export const applicantSchema = yup.object().shape({
	name: yup.string().required('Name is required.'),
	email: yup.string().email().required('Email is required.'),

	address: yup.string().required('Mailing address is required.'),
	phone: yup.string().required('Phone is required.'),
	//.matches(/\(?([0-9]{3})\)\s([0-9]{3})[-.●]?([0-9]{4})$/, 'Format: (xxx) xxx-xxxx'),
	city: yup.string().required('City is required.'),
	state: yup.string().required('State is required.'),
	zip: yup
		.string()
		.required('ZIP code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip code.'),
});
